import { getServices } from '~/db/services';

export const useGamingSave = async () => {
  const gaming = useGamingStore();
  const context = useContextStore();
  const { $db } = useNuxtApp();
  const { gamingsService } = getServices($db);
  try {
    await gamingsService.put({
      id: context.userId,
      data: toRaw(gaming.data),
    });

    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
};
